import config from "../app/config";

export const isSpecialSmallDeviceDetect = () => {
    let list = config.specialSmallDeviceName || [];
    list = list.map(el => el.toLowerCase());
    let checkDevice = false;
    let getFromForce = false;

    // Check current sesion saved option
    if (config?.smallDevice?.smallDeviceSwitchEnable && window?.sessionStorage) {
        checkDevice = window.sessionStorage.getItem("agyle_sessionForceMobileView") === "true";
        getFromForce = true;
    }

    // Check saved option
    if (!getFromForce && !checkDevice && config?.smallDevice?.smallDeviceSwitchEnable && window?.localStorage) {
        checkDevice = window.localStorage.getItem("agyle_forceMobileView") === "true";
    }

    if (!getFromForce && !checkDevice && list && list?.length > 0 && !!navigator.userAgent) {
        let checkDevice = false;
        list.forEach(device => {
            if (checkDevice) return;
            checkDevice = navigator.userAgent.toLowerCase().includes(device);
        });
    }

    if (!getFromForce && !checkDevice && config?.smallDevice?.smallDeviceMinWidth) {
        checkDevice = Number(window.innerWidth) < Number(config?.smallDevice?.smallDeviceMinWidth);
    }

    return checkDevice;
};